import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5020b9ac&scoped=true"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=5020b9ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5020b9ac",
  null
  
)

export default component.exports